import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  add: {
    id: 'manage-services.components.recurring-schedule.add',
    defaultMessage: 'Add availability',
  },
  day: {
    id: 'manage-services.components.recurring-schedule.day',
    defaultMessage: 'Day',
  },
  startTime: {
    id: 'manage-services.components.recurring-schedule.start-time',
    defaultMessage: 'Start time',
  },
  endTime: {
    id: 'manage-services.components.recurring-schedule.end-time',
    defaultMessage: 'End time',
  },
  startTimePlaceholder: {
    id: 'manage-services.components.recurring-schedule.start-time-placeholder',
    defaultMessage: 'Select start time',
  },
  endTimePlaceholder: {
    id: 'manage-services.components.recurring-schedule.end-time-placeholder',
    defaultMessage: 'Select end time',
  },
  label: {
    id: 'manage-services.components.recurring-schedule.label',
    defaultMessage: 'Recurring availability',
  },
  description: {
    id: 'manage-services.components.recurring-schedule.description',
    defaultMessage: 'Select a day of the week to set your hourly availability.',
  },
  startTimeAfterEndTime: {
    id: 'manage-services.components.recurring-schedule.start-time-after-end-time',
    defaultMessage: 'Start time cannot be later than end time',
  },
});
